import React from "react";
import "./RefundPolicy.css"; // Use the different styling CSS

export default function RefundPolicy({
  siteName = "Engineers Againest Corrosion For Certified Excellence",
  siteUrl = "https://eac-international.com",
  contactEmail = "heramb@eac-international.com",
  lastUpdated = "Jan 1, 2026",
}) {
//   const handlePrint = () => window.print();

  return (
    <main className="refund-container">
      <header className="refund-header">
        <div>
          <h1>Refund Policy for {siteName}</h1>
          <p>Last updated: {lastUpdated}</p>
          <p>
            Website: <a href={siteUrl}>{siteUrl}</a>
          </p>
          <p>
            Contact: <a href={`mailto:${contactEmail}`}>{contactEmail}</a>
          </p>
        </div>
        {/* <button onClick={handlePrint} className="refund-print-btn">
          Print / Save PDF
        </button> */}
      </header>

      <section className="refund-content">
        <p>
          At <strong>{siteName}</strong>, we strive to provide the best courses and services. However, if you are not satisfied,
          our refund policy applies as follows.
        </p>

        <h2>1. Eligibility for Refund</h2>
        <ul>
          <li>Refunds are only applicable for courses or services purchased directly from {siteName}.</li>
          <li>Refund requests must be made within 7 days of purchase unless otherwise specified.</li>
          <li>No refunds are available for completed courses or services already accessed.</li>
        </ul>

        <h2>2. Non-Refundable Items</h2>
        <ul>
          <li>Gift cards or promotional codes.</li>
          <li>Any course material already downloaded or accessed.</li>
          <li>Third-party services or partner courses.</li>
        </ul>

        <h2>3. Refund Process</h2>
        <ul>
          <li>Submit a refund request to <a href={`mailto:${contactEmail}`}>{contactEmail}</a> with purchase details.</li>
          <li>Refunds will be processed within 7-14 business days to the original payment method.</li>
          <li>{siteName} reserves the right to approve or deny any refund request based on the eligibility criteria.</li>
        </ul>

        <h2>4. Next Batch Option</h2>
        <p>
          If a user purchases a course but the selected batch is full or unavailable due to any other condition, the user is
          entitled to join the next available batch of the same course without any additional cost.
        </p>

        <h2>5. Contact Us</h2>
        <p>
          For questions or refund requests, please contact us at <a href={`mailto:${contactEmail}`}>{contactEmail}</a> or visit <a href={siteUrl}>{siteUrl}</a>.
        </p>
      </section>
    </main>
  );
}
